export enum ContactPersonsTableActionType {
  CreateInvoice = 'createInvoice',
  CreateQuote = 'createQuote',
  Edit = 'edit',
  Delete = 'delete',
}
